/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMedicalCrossCircle = createReactComponent("outline", "medical-cross-circle", "IconMedicalCrossCircle", [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 8v8", "key": "svg-1" }], ["path", { "d": "M15.5 10l-7 4", "key": "svg-2" }], ["path", { "d": "M15.5 14l-7 -4", "key": "svg-3" }]]);

export { IconMedicalCrossCircle as default };
//# sourceMappingURL=IconMedicalCrossCircle.mjs.map
